'use strict';

module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chart.js/src/charts/Chart.Bar.js
// module id = 2410
// module chunks = 0